import { FontWeight, Heading, Text } from '@lili/lili-frontend-common';
import React from 'react';
import Icon from '../../../generic-components/Icon';

interface GreyBgCardIProps {
  title: string;
  text: string | React.ReactNode;
  iconId: string;
  iconSrc: string;
}
export const GreyBgCard = ({ title, text, iconId, iconSrc }: GreyBgCardIProps) => (
  <div className='h-full border p-[32px] border-outline-primary-bw-03 bg-surface-primary-bw-01 rounded-[8px] gap-4'>
    <div className='flex flex-col '>
      <Icon iconId={iconId} className='w-[72px] h-[72px]' src={iconSrc} />
      <Heading.H9 fontWeight={FontWeight.MEDIUM} id='getPaidEarlierTitle' className='pb-[5px] pt-[16px]'>
        {title}
      </Heading.H9>
      <Text.H10 id='getPaidEarlierText' className='font-metricR leading-4 text-[14px] text-bw07'>
        {text}
      </Text.H10>
    </div>
  </div>
);
